import StayLimitFormConfig from './configurations/StayLimitFormConfig';
import StayLimitTableConfig from './configurations/StayLimitTableConfig';
import BlockedDaysFormConfig from './configurations/BlockedDaysFormConfig';
import BlockedDaysTableConfig from './configurations/BlockedDaysTableConfig';
import BookingBlockedDaysTableConfig from './configurations/BookingBlockedDaysTableConfig';

export const configurations = [
  {
    api: 'blocked-days',
    label: 'Zablokowane dni',
    creationLabel: 'Dodaj blokadę',
    fields: BlockedDaysFormConfig,
    columns: BlockedDaysTableConfig,
    editable: false,
    deleteModalTitle: 'Usunięcie blokady',
    deleteModalDescription: 'Czy na pewno chcesz usunąć te zablokowane dni?',
  },
  {
    api: 'booking-blocked-days',
    label: 'Zablokowane dni Booking',
    tableLabel: 'Zablokowane dni Booking',
    columns: BookingBlockedDaysTableConfig,
    readOnly: true,
    removable: false,
    editable: false,
  },
  {
    api: 'stay-limit',
    label: 'Ograniczenia pobytu',
    creationLabel: 'Dodaj ograniczenie pobytu',
    fields: StayLimitFormConfig,
    columns: StayLimitTableConfig,
    editable: false,
    deleteModalTitle: 'Usunięcie ograniczenia pobytu',
    deleteModalDescription: 'Czy na pewno chcesz usunąć te ograniczenie pobytu?',
  },
];
